function tel_mask() {
	$("input[type=\"tel\"]").keydown(function (e) {
		if ($.inArray(e.keyCode, [173, 107, 109, 46, 8, 9, 27, 13, 110, 32, 190, 189]) !== -1 ||// Allow: backspace, delete, tab, escape, enter, space, and .
			e.keyCode === 65 && e.ctrlKey ||// Allow: Ctrl+A
			e.keyCode === 67 && e.ctrlKey ||// Allow: Ctrl+C
			e.keyCode === 88 && e.ctrlKey ||// Allow: Ctrl+X
			e.keyCode === 86 && e.ctrlKey ||// Allow: Ctrl+V
			e.keyCode === 187 && e.shiftKey ||// Allow: + with shift
			e.keyCode === 57 && e.shiftKey ||// Allow: ( with shift
			e.keyCode === 48 && e.shiftKey ||// Allow: ) with shift
			e.keyCode >= 35 && e.keyCode <= 39) {// Allow: home, end, left, right
			return   // let it happen, don't do anything
		}// Ensure that it is a number and stop the keypress
		if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
			e.preventDefault()
		}
	});
}

function hideShowMoreButton(){
	if ($('.pagination li.active').next('li').find('a.has_link').length == 0) {
		$('#showmore').hide();
		$('#showmorearticles').hide();
		$('#showmorereviews').hide();
	}
}

function activeMenuItem(){
	var menu = $('#header_menu');

	if(menu){
		menu.find('li a').each(function () {
			if ($(location).attr('href').indexOf($(this).attr('href')) >= 0){
				$(this).addClass('active');
				$(this).attr("href", "javascript:void(0)");
				return;
			}
		});
	}
}

function activeCatItem(){
	var menu = $('.box_categories .box_content');

	if(menu){
		menu.find('li a').each(function () {
			if ($(location).attr('href').indexOf($(this).attr('href')) >= 0){
				$(this).addClass('active');
				$(this).attr("href", "javascript:void(0)");
				return;
			}
		});
	}
}

function customLabelInput(){
	$('.input_container').mouseover(function(){
		$(this).addClass('active_label');
	});
	$('.input_container').mouseout(function(){
		$(this).removeClass('active_label');
	});

}
function openWin2($url) {
	myWin = open("http://www.facebook.com/sharer.php?u=" + $url, "displayWindow", "width=520,height=300,left=350,top=170,status=no,toolbar=no,menubar=no");
}
function loacation() {
	location.reload();
}
function getURLVar(key) {
	var value = [];

	var query = String(document.location).split('?');

	if (query[1]) {
		var part = query[1].split('&');

		for (i = 0; i < part.length; i++) {
			var data = part[i].split('=');

			if (data[0] && data[1]) {
				value[data[0]] = data[1];
			}
		}

		if (value[key]) {
			return value[key];
		} else {
			return '';
		}
	}
}
function onlyDigit(){
	$("input.qty").keypress(function(e) { //if the letter is not digit then display error and don't type anything
		if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
			return false
		}
	});
	$("input.digit").keypress(function(e) { //if the letter is not digit then display error and don't type anything
		if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
			return false
		}
	});
}

function customSelectInit(){
	console.log('customSelect_Init');
	$(".custom-select select").each(function() {
		if(!$(this).hasClass('is-customized')) {
			$(this).addClass('is-customized');
			var sb = new SelectBox({
				selectbox: $(this),
				customScrollbar: true,
				height: 300,
				changeCallback: function() {
					//alert("I was changed!");
				}

			});
		};
	});
}

function fixTopLine() {
	console.log('fixTopLine');
	var headerHeight = $('.header__top_block').outerHeight();
	if ($(window).width() >= 1024) {

		$(".header__bottom_block").removeClass("fixed");
		if ($(this).scrollTop() > headerHeight) {
			$(".header__bottom_block").addClass("fixed");
		} else {
			$(".header__bottom_block").removeClass("fixed");
		};


		$(window).scroll(function () {
			if ($(this).scrollTop() > headerHeight) {
				$(".header__bottom_block").addClass("fixed");
			} else {
				$(".header__bottom_block").removeClass("fixed");
			};
		});
	}
}

function scrollToUp(){
	$(window).scroll(function () {
		if ($(this).scrollTop() > 150) {
			$("#up_button").addClass("active");
		} else {
			$("#up_button").removeClass("active");
		};
	});

	$('#up_button').click(function(){
		$('html, body').animate({scrollTop: '0px'}, 300);
	})
}

function catDescToggle(){
	if ($('.cat_description').length){
		$('.cat_description .readmore a').click(function(){
			$('.cat_description_content').toggleClass('full');
			$(this).toggleClass('active');
		});
	}
}



function closeMobMenu(){
	$('body').removeClass('overflow_hidden');
	$('#mobile_menu').removeClass('active');
}

function quickLogin(){

	$('.quicksignup-button-nologged').click(function(){
		closeMobMenu();
		//$('#modal-quicksignup').modal();
	});

	$('#quick-login input').on('keydown', function(e) {
		if (e.keyCode == 13) {
			$('#quick-login .loginaccount').trigger('click');
		}
	});
	$('#quick-login .loginaccount').click(function() {

		$.ajax({
			url: 'index.php?route=common/quicksignup/login',
			type: 'post',
			data: $('#quick-login input[type=\'text\'], #quick-login input[type=\'password\']'),
			dataType: 'json',
			beforeSend: function() {
				$('#quick-login .alert-danger').remove();
			},
			complete: function() {
				$('#quick-login .loginaccount').button('reset');
			},
			success: function(json) {
				$('#quick-login input').removeClass('has_error');
				if(json['islogged']){
					window.location.href="index.php?route=account/simpleedit";
				}

				if (json['error']) {
					$('#quick-login').prepend('<div class="alert alert-danger"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
					$('#quick-login #input-email').addClass('has_error');
					$('#quick-login #input-password').addClass('has_error');
				}
				if(json['success']){
					let url = window.location.href;
					let page = url.substr(url.substr(0, (url + "?").indexOf("?")).lastIndexOf("/") + 1);
					//console.log(page);
					if((page == 'logout') || (page == 'index.php?route=account/logout')){
						console.log('in_logout');
						//return;
						document.location.href = "/";
					}else{
						console.log('no_logout');
						//return;
						loacation();
					}

					$('#modal-quicksignup').modal('hide');
				}

			},
			error: function(xhr, ajaxOptions, thrownError) {
				console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	});


}
function quickRegister(){

	$('.quicksignup-button-nologged').click(function(){
		closeMobMenu();
		$('#modal-quicksignup-register').modal();
	});


	$('#quick-register input').on('keydown', function(e) {
		if (e.keyCode == 13) {
			$('#quick-register .createaccount').trigger('click');
		}
	});
	$('#quick-register .createaccount').click(function() {
		$.ajax({
			url: 'index.php?route=common/quicksignup/register',
			type: 'post',
			data: $('#quick-register input[type=\'text\'], #quick-register input[type=\'tel\'], #quick-register input[type=\'password\'], #quick-register input[type=\'checkbox\']:checked'),
			dataType: 'json',
			beforeSend: function() {
				//$('#quick-register .createaccount').button('loading');
				$('#quick-register .text-danger').remove();
				$('.alert-danger').remove();
			},
			complete: function() {
				//$('#quick-register .createaccount').button('reset');
			},
			success: function(json) {
				$('#quick-register .input_container').removeClass('has-error');
				$('#quick-register .reset_input').removeClass('has_error');
				$('#quick-register .input_container .text-danger').remove();
				if(json['islogged']){
					window.location.href="index.php?route=account/edit";
				}
				if (json['error_firstname']) {
					$('#quick-register #input-firstname').addClass('has_error');
					$('#quick-register #input-firstname').after('<div class="text-danger">' + json['error_firstname'] + '</div>');
					$('#quick-register #input-firstname').focus();
				}

				if (json['error_email']) {
					$('#quick-register #input-register-email').addClass('has_error');
					$('#quick-register #input-register-email').after('<div class="text-danger">' + json['error_email'] + '</div>');
					$('#quick-register #input-register-email').focus();
				}
				if (json['error_telephone']) {
					$('#quick-register #input-telephone').addClass('has_error');
					$('#quick-register #input-telephone').after('<div class="text-danger">' + json['error_telephone'] + '</div>');
					$('#quick-register #input-telephone').focus();
				}
				if (json['error_password']) {
					$('#quick-register #input-register-password').addClass('has_error');
					$('#quick-register #input-register-password').after('<div class="text-danger">' + json['error_password'] + '</div>');
					$('#quick-register #input-register-password').focus();
				}


				if (json['error_agree']) {
					$('#quick-register #register_agree_label').after('<div class="text-danger">' + json['error_agree'] + '</div>');
				}

				/*if (json['error']) {
					$('#quick-register').after('<div class="alert alert-danger" style="margin:5px;">' + json['error'] + '</div>');
				}*/


				if (json['success']) {

					$("#modal_container_success .modal-header .title").html(json['text_thanks_title']);
					$("#modal_container_success .modal-body .text").html(json['text_thanks_content']);

					$("#modal-quicksignup-register input").val('');

					$("#modal-quicksignup-register").modal('hide');

					$("#modal_container_success").modal();

					if (json['now_login']) {
						//window.location.href="index.php?route=account/account";
						setTimeout(function () {
							document.location.href = "index.php?route=account/simpleedit";
						}, 4000)


						$('.quickregister_slide .heading button').click(function(){
							setTimeout(function () {
								//document.location.reload(true);
								document.location.href = "index.php?route=account/simpleedit";
							}, 1000)
						})


					}

				}


			},
			error: function(xhr, ajaxOptions, thrownError) {
				//console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	});
}
function openLoginRegister(){
	$('.sign_register_modal .modal-header .open_login').click(function(){
		$('#modal-quicksignup-register').modal('hide');
		$('#modal-quicksignup').modal();
	});

	$('.sign_register_modal .modal-header .open_register').click(function(){
		$('#modal-quicksignup').modal('hide');
		$('#modal-quicksignup-register').modal();
	})
}
function resetPassword(){

	$('#modal-quicksignup a.forgotten').click(function(){
		$('#modal-quicksignup').modal('hide');
		setTimeout(function () {
			$('#modal_forgot_password').modal();
		}, 400);
	})

	$('.open_login_form').click(function(){
		$('#modal_forgot_password').modal('hide');
		setTimeout(function () {
			$('#modal-quicksignup').modal();
		}, 400);
	});


	$('#modal_forgot_password .reset_pass').click(function() {
		console.log('reset_pass');
		$.ajax({
			//url: 'index.php?route=account/forgotten/reset_pass',
			url: 'index.php?route=account/forgotten/index',
			type: 'post',
			data: $('#modal_forgot_password input[type=\'email\']'),
			dataType: 'json',
			beforeSend: function() {
			},
			complete: function() {
			},
			success: function(json) {
				$('#modal_forgot_password .input_container input').removeClass('has_error');
				$('#modal_forgot_password .input_container .text-danger').remove();
				$('#modal_forgot_password .inputs_container .alert').remove();

				if(json['islogged']){
					window.location.href="index.php?route=account/account";
				}

				if (json['error_empty_email']){
					$('#modal_forgot_password .input_container input').addClass('has_error');
					$('#modal_forgot_password .input_container').append('<div class="text-danger">' + json['error_empty_email'] + '</div>');
					return;
				}
				if (json['error_noexist']){
					$('#modal_forgot_password .input_container input').addClass('has_error');
					$('#modal_forgot_password .input_container').append('<div class="text-danger">' + json['error_noexist'] + '</div>');
					return;
				}
				if (json['error_isnot_email']){
					$('#modal_forgot_password .input_container input').addClass('has_error');
					$('#modal_forgot_password .input_container').append('<div class="text-danger">' + json['error_isnot_email'] + '</div>');
					return;
				}

				if(json['success']){
					$('#modal_forgot_password').modal('hide');
					$('#modal_forgot_password input').val('');

					$('#modal_container_success').addClass('reset_pass_success');
					$('#modal_container_success .modal-header .title').html(json['success']);
					$('#modal_container_success .modal-body .text').html(json['success_reset_pass_text']);
					$('#modal_container_success').modal();

				}

			}
		});
	});
}
function goToUserCabinet(){
	$('.quicksignup-button-logged').click(function(){
		window.location.href="index.php?route=account/simpleedit";
	})
}

function openCloseSearch(){
	$('.header__bottom_block .search').mouseover(function(){
		$(this).find('.search_dropdown').addClass('active');
	});

	$('html').click(function() {
		$('.header__bottom_block .search .search_dropdown').removeClass('active');
	});
	$('.header__bottom_block .search .search_dropdown').click(function(event){
		event.stopPropagation();
	})
	$('.header__bottom_block .search').click(function(event){
		event.stopPropagation();
	})

}






function mainSlideshow(){
	if($('#main_slideshow').length) {
		$('#main_slideshow').slick({
			fade: true,
			infinite: false,
			arrows: true,
			prevArrow: '<span class="icon icon-arrow-left"></span>',
			nextArrow: '<span class="icon icon-arrow-right"></span>',
			dots: false,
			autoplay: true,
			autoplaySpeed: 4000,
			appendArrows: $('#main_slideshow_container .arrows_container .container'),
		});
	}
}
function productsSlider() {
	if ($('.products_slider').length) {

		$('.products_slider').each( function() {
			$( this ).slick( {
				dots: false,
				autoplay: false,
				infinite: false,
				arrows: true,
				prevArrow: '<span class="icon icon-arrow-left"></span>',
				nextArrow: '<span class="icon icon-arrow-right"></span>',
				speed: 300,
				slidesToShow: 5,
				slidesToScroll:1,
				appendArrows: $(this).parents('.box_products').find('.box_heading .arrows_container'),

				responsive: [{
					breakpoint: 1700,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},{
					breakpoint: 768, settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}}
				]
			} );
		} );
	}
}
function advantagesPopup() {
	if($('.box_blog').length){
		$('.box_blog .item .readmore a').click(function(e){
			e.preventDefault();
			var articleId = $(this).data('id');
			$('#modal_advantages .modal-body').load('index.php?route=blog/article&article_id='+ articleId, function() {
				$('#modal_advantages').modal();
			});
		});
	}
}
function sendNewsLetterForm(){
	$('#newsletter_submit').click(function() {
		$.ajax({
			url: 'index.php?route=sendforms/send',
			type: 'post',
			data: $('#newsletter_form').serialize(),
			dataType: 'json',

			success: function(json) {

				$('#newsletter_form input').removeClass('has_error');
				$('.newsletter_form_container .text-danger').remove();


				if (json['error_email']) {
					$('#newsletter_form input').addClass('has_error');
					$('#newsletter_form .input_container').append('<div class="text-danger">' + json['error_email'] + '</div>');
					$('#newsletter_form input').focus();
				}

				if (json['success']) {
					$('#modal_container_success .modal-header .title').html(json['success_title']);
					$('#modal_container_success .modal-body .text').html(json['success_newsletter']);
					$('#modal_container_success').modal();

					$('#newsletter_form .reset_input').val('')
					$('#newsletter_form .reset_input').removeClass('has_error');
					$('.newsletter_form_container .text-danger').remove();
				}

			},
			error: function(xhr, ajaxOptions, thrownError) {
				console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	});
}

function showHideMobileSearch(){
	console.log('showHideMobileSearch');
	$('.mobile_header .searchToggle').click(function(){
		$('.mobile_header .search').addClass('active')
	});
	$('.mobile_header .search .search_close').click(function(){
		$('.mobile_header .search').removeClass('active')
	});
}
function mobileMenuOpenClose(){
	$('.hamburger_button').click(function(){
        $('body').addClass('overflow_hidden');
		$('#mobile_menu').addClass('active');
	});

	$('.mobile_menu_header .mobile_menu_close').click(function(){
		$('body').removeClass('overflow_hidden');
		$('#mobile_menu').removeClass('active');
	});

}
function closeMobMenu(){
	$('body').removeClass('overflow_hidden');
	$('#mobile_menu').removeClass('active');
}
function mobileMenuSublevels(){
	$('#mobile_menu .catalog_menu .child_button').click(function(){
		if($(this).parents('.has_child').hasClass('active')){
			$('#mobile_menu .catalog_menu .has_child').removeClass('active');
		}else {
			$('#mobile_menu .catalog_menu .has_child').removeClass('active');
			$(this).parents('.has_child').addClass('active');
		}
	});

}
function toggleFooterMobile(){
	$('.footer__top_block .col_title').click(function(){
		$(this).find('.toggleButton').toggleClass('active');
		$(this).parents('.col').find('.col_content').toggleClass('active');
	});
}





function mobileFiltering() {
	$("body").on("click", ".open_filter", function () {
		$('body').addClass('overflow_hidden');
		$('.mfilter-free-container').addClass('open');
	});

	$("body").on("click", "#mfilter-free-container-0 .box-heading .icon-close", function () {
		$('body').removeClass('overflow_hidden');
		$('.mfilter-free-container').removeClass('open');
	})

	$('.filter_close_buttons .filter_close').click(function () {
		$('body').removeClass('overflow_hidden');
		$('.mfilter-free-container').removeClass('open');
	});

	$('.filter_close_buttons .filter_reset').click(function () {
		$('a.mfilter-button-reset').trigger('click');
	});
}



function productPageSlider(){

	if ($('.product-big-image.gallery').length){
		setTimeout(function(){
			$('.product-big-image.gallery').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				prevArrow: '<span class="ani icon icon-arrow-left"></span>',
				nextArrow: '<span class="ani icon icon-arrow-right"></span>',
				asNavFor: '.additional_images',
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							arrows: true,
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});


			$('.additional_images').slick({
				infinite: true,
				autoplay: false,
				autoplaySpeed: 4000,
				vertical: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				asNavFor: '.product-big-image',
				arrows: false,
				dots: false,
				centerMode: false,
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},{
						breakpoint: 991,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					},{
						breakpoint: 600,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]

			});
		}, 200);
		$('.product-big-image.gallery a').magnificPopup({
			type:'image',
			gallery: {
				enabled: true
			}
		});

	};


	if ($('.product-big-image').length){
		$('.product-big-image a.popup').magnificPopup({
			type:'image',
			gallery: {
				enabled: false
			}
		});
	}

}
function openSharingBlock(){
	$('.share_block .open_sharing').click(function(){
		$(this).prev().toggleClass('active');
	});

	$('html').click(function() {
		$('.share_block_content').removeClass('active');
	});
	$('.share_block_content').click(function(event){
		event.stopPropagation();
	})
	$('.share_block .open_sharing').click(function(event){
		event.stopPropagation();
	})

}
function changeQty(){
	$(document).on('click', '.qty_wrap .bnt_plus', function () {
		console.log('plus');
		var num = parseInt($(this).prev().val());
		var available_qty = parseInt($(this).prev().data('qty'));
		var min = parseInt($(this).prev().data('min'));
		$(this).prev().val(num + min);

		if ($(this).hasClass('popup_cart_btn')) {

			key = $(this).prev().data('id');
			quantity = $(this).prev().val();
			product_id = $(this).prev().data('product-id');

			cart.update(key, quantity, product_id);

		}



	});
	$(document).on('click', '.qty_wrap .bnt_minus', function () {
		console.log('minus');
		if ($(this).next().val() > $(this).next().data('min')) {
			var num = parseInt($(this).next().val());
			$(this).next().val(num - parseInt($(this).next().data('min')))

			if ($(this).hasClass('popup_cart_btn')) {
				key = $(this).next().data('id');
				quantity = $(this).next().val();
				product_id = $(this).next().data('product-id');
				cart.update(key, quantity, product_id);
			}



		}


	});

}


function customProgressSet(){
	if ($('.custom_progress').length){
		$options_length = $('#pat_payment_pp option').length - 1;
		$step = parseInt(100 / $options_length);


		const progress = document.querySelector('.custom_progress');
		$value = progress.value;
		if($value == 1) {
			$value = 0;
		}else if($value == 2){
			$value = $step;
		}else{
			$value = ($value - 1) * $step;
		}
		progress.style.background = `linear-gradient(to right, #000000 0%, #000000 ${$value}%, #CBD1DA ${$value}%, #CBD1DA 100%)`
	}
}

function customProgressSlider(){
	if ($('.custom_progress').length){

		$options_length = $('#pat_payment_pp option').length - 1;
		$step = parseInt(100 / $options_length);

		const progress = document.querySelector('.custom_progress');
		progress.addEventListener('input', function () {
			$value = parseInt(this.value);
			if($value == 1) {
				$value = 0;
			}else if($value == 2){
				$value = $step;
			}else{
				$value = ($value - 1) * $step;
			}
			this.style.background = `linear-gradient(to right, #000000 0%, #000000 ${$value}%, #CBD1DA ${$value}%, #CBD1DA 100%)`
		})
	}
}

function render_private_pp(element){

	var product_id = $('#product').find('input[name=product_id]').val();
	var product_id = parseInt(product_id);
	if (isNaN(product_id)) {
		return;
	}

	var input_val = $('#product').find('input[name=quantity]').val();
	var quantity = parseInt(input_val);
	if (isNaN(quantity)) {
		quantity = 1;
	}


	if(typeof(element) == 'undefined'){
		element = '#modal_container_credit #pat_payment_pp';
	}

	var value = $(element).val();
	value = parseInt(value);
	if (isNaN(value)) {
		value = 2;
	} else {
		value += 1;
	}


	$.ajax({
		url: 'index.php?route=product/product/update_prices&pp_product_id=' + product_id + '&pp_quantity=' + quantity + '&count_pp=' + value,
		type: 'post',
		dataType: 'json',
		beforeSend: function() {
			//$(".payment-pat-ppt_modal .inner").addClass("load");
		},
		complete: function() {
			//$(".payment-pat-ppt_modal .inner").removeClass("load");
		},
		success: function (json) {
			$('#modal_container_credit .pat_payment_price').text(json['count_price_pp'] + ' = ' + json['price']);
			$('#modal_container_credit .pat_payment_range').text(value);
			$("#modal_container_credit #pat_payment_pp_range").val(value-1);
			$("#modal_container_credit #pat_payment_pp").val(value-1);
			$('#modal_container_credit #pat_payment_pp').parent().find('.selectedValue').text($('#modal_container_credit #pat_payment_pp option:selected').text());
			customProgressSet();
		},
		error: function (xhr, ajaxOptions, thrownError) {
			console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
		}
	});
}

function addToCartFromProductCard(){
	if(('#product').length) {

		//клік по оплаті частинами
		$(document).on('click', '#product .credit', function () {
			$('#modal_container_credit').modal();
			$('#modal_container_credit .row_col_error .text-danger').remove();
			render_private_pp();
		});

		$(document).on('change', '#modal_container_credit #pat_payment_pp', function () {
			 render_private_pp('#modal_container_credit #pat_payment_pp');
		});

		$(document).on('change', '#modal_container_credit #pat_payment_pp_range', function () {
			render_private_pp('#modal_container_credit #pat_payment_pp_range');
		});

		$(document).on('click', '#modal_container_credit #pp_button-cart', function () {

			$.ajax({
				url: 'index.php?route=checkout/cart/add',
				type: 'post',
				data: $('#product input[type=\'text\'], #product input[type=\'hidden\'], #product input[type=\'radio\']:checked, #product input[type=\'checkbox\']:checked, #product select, #product textarea, #modal_container_credit select' ),
				dataType: 'json',
				beforeSend: function () {
					//$('#button-cart').button('loading');
				},
				complete: function () {
					//$('#button-cart').button('reset');
				},
				success: function (json) {

					$('#modal_container_credit .row_col_error .text-danger').remove();

					if (json['error']) {
						if (json['error']['option']) {
							for (i in json['error']['option']) {
								$('#modal_container_credit .row_col_error').append('<div class="text-danger">' + json['error']['option'][i] + '</div>');
							}
						}
						if (json['error']['recurring']) {
							$('#modal_container_credit .row_col_error').append('<div class="text-danger">' + json['error']['recurring'] + '</div>');

						}
					}

					if (json['success']) {


						if (json['dataLayer'] && typeof dataLayer !== 'undefined') {
							$('body').append(json['dataLayer']);
						}

						if (json['fbq'] && typeof fbq !== 'undefined') {
							$('body').append(json['fbq']);
						}

						setTimeout(function () {
							location = '/index.php?route=checkout/simplecheckout';

						},500)

					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
					alert(thrownError + "/r/n" + xhr.statusText + "/r/n" + xhr.responseText);
				}
			});


		});

		//клік по самій карті продукту

		$(document).on('click', '#product .buy_button', function () {

			$.ajax({
				url: 'index.php?route=checkout/cart/add',
				type: 'post',
				data: $('#product input[type=\'text\'], #product input[type=\'hidden\'], #product input[type=\'radio\']:checked, #product input[type=\'checkbox\']:checked, #product select, #product textarea'),
				dataType: 'json',
				beforeSend: function () {
					//$('#button-cart').button('loading');
				},
				complete: function () {
					//$('#button-cart').button('reset');
				},
				success: function (json) {
					$('.alert, .text-danger').remove();
					$('.form-group').removeClass('has-error');

					if (json['error']) {

						if($(window).width() < 991){
							$([document.documentElement, document.body]).animate({
								scrollTop: $("#options_anchor").offset().top - 90
							}, 2000);
						}

						if (json['error']['option']) {
							for (i in json['error']['option']) {
								var element = $('#input-option' + i.replace('_', '-'));
								if (element.parent().hasClass('input-group')) {
									element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
								} else {
									element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
								}
							}

							var dop_element = $('#dop-input-option' + i.replace('_', '-'));
							if (dop_element.parent().hasClass('input-group')) {
								dop_element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
							} else {
								dop_element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
							}
						}

						if (json['error']['recurring']) {
							$('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
						}

						// Highlight any found errors
						$('.text-danger').parent().addClass('has-error');
					}

					if (json['success']) {

						if (json['dataLayer'] && typeof dataLayer !== 'undefined') {
							$('body').append(json['dataLayer']);
						}

						if (json['fbq'] && typeof fbq !== 'undefined') {
							$('body').append(json['fbq']);
						}


						setTimeout(function () {

							$("#modal_container_addcart #cart_popup_product_list > ul").load("index.php?route=common/cart/info ul li", function () {

								$('#modal_container_addcart .modal-header .title span').text('(' + json['total'] + ')');

								setTimeout(function () {
									onlyDigit()
								}, 100);
								$('#modal_container_addcart').modal();
							});


							let product_name = $('#product .product__top_block h1.name a').text();
							$('#modal_cart .info').text(product_name);

							$('.cart_button .cart-total' ).html(json['total']);
							$('.cart_button .cart-total').addClass('active');


							$('#modal_cart').addClass('active');

							$('#modal_cart .heading button').click(function(){
								$('#modal_cart').removeClass('active');
							});
							setTimeout(function () {
								$('#modal_cart').removeClass('active');
							}, 4000);


						}, 100);

					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
					alert(thrownError + "/r/n" + xhr.statusText + "/r/n" + xhr.responseText);
				}
			});


		});
	}

}

function DataLayerPush(dataLayer_data) {
	if (typeof dataLayer !== 'undefined') {
		var dataLayer_data
		dataLayer.push({ecommerce: null});
		dataLayer.push(dataLayer_data);
		console.log(dataLayer_data)
	}
}


function fbqPush(fbq_data) {
	if (typeof fbq !== 'undefined') {
		var fbq_data
		console.log(fbq_data)
	}
}


function get_popup_purchase(product_id) {
	$.ajax({
		url: 'index.php?route=extension/module/popup_purchase&product_id='+product_id,
		type: 'post',
		success: function(response) {
			// Add response in Modal body
			$('#modal_container_fastorder .modal-body').html(response);
			$('#modal_container_fastorder').modal();
			tel_mask();
			//$("#popup_purchase_telephone").mask("+38 999 999 99 99");
			popup_purchase_buy();
		}
	});
};
function popup_purchase_buy(){
	$('#popup-checkout-button').click(function() {
		$.ajax({
			type: 'post',
			url:  'index.php?route=extension/module/popup_purchase/make_order',
			dataType: 'json',
			data: $('#purchase-form').serialize(),
			success: function(json) {

				if (json['error']) {
					$('#purchase-form .input_container').removeClass('has-error');
					$('#purchase-form .text-danger').remove();

					if (json['error']['field']) {
						//masked('#popup-purchase-wrapper', false);
						$('#popup-purchase-wrapper .input_container').removeClass('has-error');
						$('#popup-purchase-wrapper label.error').remove();
						$.each(json['error']['field'], function(i, val) {
							$('#popup-purchase-wrapper [name="' + i + '"]').parent().addClass('has-error');
							$('#popup-purchase-wrapper [name="' + i + '"]').after('<div class="text-danger">' + val + '</div>');
						});
					}

					if (json['error']['option']) {
						for (i in json['error']['option']) {
							//masked('#popup-purchase-wrapper', false);
							$('#popup-purchase-wrapper .required .error').remove();
							var element = $('#popup-purchase-wrapper #input-option' + i.replace('_', '-'));
							element.after('<label class="error">' + json['error']['option'][i] + '</label>');
						}
					}

					if (json['error']['recurring']) {
						$('#popup-purchase-wrapper select[name=\'recurring_id\']').after('<label class="error">' + json['error']['recurring'] + '</label>');
					}

					if (json['error']['error_agree']){
						$('#popup-purchase-wrapper input[name="agree"]').parent().find('label').after('<label class="error">' + json['error']['error_agree'] + '</label>');
						$('#popup-purchase-wrapper input[name="agree"]').parent().addClass('has-error');
					}

				} else {
					$('#popup-purchase-wrapper .input_container').removeClass('has-error');

					if (json['output']) {
						$('#modal_container_fastorder').modal('hide');
						$('#purchase-form input').val('');
						$('#modal_container_success .modal-header .title').text(json['output_title']);
						$('#modal_container_success .modal-body').text(json['output']);

						setTimeout(function () {
							$('#modal_container_success').modal();
						}, 700)

					}
				}
			}
		});
	});
}
function update_prices(product_id) {

	var input_val = $('#purchase-form').find('input[name=quantity]').val();
	console.log(input_val);
	var quantity = parseInt(input_val);

	$.ajax({
		url: 'index.php?route=extension/module/popup_purchase/update_prices&product_id=' + product_id + '&quantity=' + quantity,
		type: 'post',
		dataType: 'json',
		data: $('#purchase-form').serialize(),
		success: function(json) {
			$('#popup-purchase-wrapper .product_price .price').html(json['price']);
			$('#popup-purchase-wrapper .product_price .special_price').html(json['special']);
			$('#main-tax').html(json['tax']);
		}
	});
}


//В статье блога , связанные статьи
function relatedArticlesSlider(){
	if($('.related_articles_slider').length){
			$('.related_articles_slider').slick( {
				dots: false,
				autoplay: true,
				infinite: true,
				arrows: true,
				prevArrow: '<span class="icon icon-arrow-left"></span>',
				nextArrow: '<span class="icon icon-arrow-right"></span>',
				speed: 300,
				slidesToShow: 3,
				slidesToScroll:1,
				appendArrows: $('.box_related_articles').find('.box_heading .arrows_container'),

				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			} );
	}
}

function sendContactsForm(){
	$('#contacts_form #contacts_submit').click(function() {
		console.log('contacts_submit_click');
		$.ajax({
			url: 'index.php?route=sendforms/send',
			type: 'post',
			data: $('#contacts_form').serialize(),
			dataType: 'json',

			success: function(json) {
				$('#contacts_form input').removeClass('has_error');
				$('#contacts_form textarea').removeClass('has_error');
				$('#contacts_form .text-danger').remove();

				if($(window).width() < 991){
					if (json['error']) {
						//if error scroll to form
						$([document.documentElement, document.body]).animate({
							scrollTop: $("#contacts_form").offset().top - 50
						}, 2000);
					}
				}

				if (json['error_name']) {
					$('#contacts_form #input-name-contacts').addClass('has_error');
					$('#contacts_form #input-name-contacts').after('<div class="text-danger">' + json['error_name'] + '</div>');
					$('#contacts_form #input-name-contacts').focus();
				}
				if (json['error_email']) {
					$('#contacts_form #input-email-contacts').addClass('has_error');
					$('#contacts_form #input-email-contacts').after('<div class="text-danger">' + json['error_email'] + '</div>');
					$('#contacts_form #input-email-contacts').focus();
				}
				if (json['error_message']) {
					$('#contacts_form #contacts_message').addClass('has_error');
					$('#contacts_form #contacts_message').after('<div class="text-danger">' + json['error_message'] + '</div>');
					$('#contacts_form #contacts_message').focus();
				}

				if (json['error_agree']) {
					$('#contacts_form .custom_check').after('<div class="text-danger">' + json['error_agree'] + '</div>');
				}


				if (json['success']) {
					$('#contacts_form .reset_input').val('');
					$('#contacts_form textarea').val('');
					//$('#contacts_form #contacts_agree').prop('checked', false);
					$('#contacts_form .reset_input').removeClass('has_error');
					$('#contacts_form .text-danger').remove();


					$("#modal_container_success .modal-header .title").html(json['success_title']);
					$("#modal_container_success .modal-body .text").html(json['success']);
					$("#modal_container_success").modal();


				}

			},
			error: function(xhr, ajaxOptions, thrownError) {
				console.log('error');
				//console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	});
}

function simplecheckoutPageHacks(){

	if($('.checkout-simplecheckout').length){
		console.log('simplecheckoutPageHacks');

		//open login popup
		$('button.quick_login').click(function(){
			$('#modal-quicksignup').modal();
			//$('#modal-quicksignup .modal-header .open_login').trigger('click');
		});

		let $submitButton = $('#simplecheckout_button_confirm');
		if (!$submitButton.attr("disabled")) {
			$( ".container_for_submit_button button" ).prop( "disabled", false );
		}else{
			$( ".container_for_submit_button button" ).prop( "disabled", true );
		}

		$( ".container_for_submit_button button" ).click(function(){
			$submitButton.trigger('click');
		});

		if($('.empty_cart_message').length){
			$('body').addClass('empty_cart');
			$.each([".cart .cart-total ,#cart_total", "#cart-total", "#cart_menu .s_grand_total", "#cart .tb_items", "#cart .tb_total", "#menu_wrap #cart-total"], function(index, selector) {
				$(selector).removeClass('active');;
			});
		}

		onlyDigit();

		//Copy to clipboard number credit card
		$('#credit_card_number_copy').click(function(){
			$card_number = $('#credit_card_number').val();
			console.log($card_number);
			/* Copy the text inside the text field */
			navigator.clipboard.writeText($card_number);

			$('.card_info_container .copy_success').addClass('active');

			setTimeout(function () {
				$('.card_info_container .copy_success').removeClass('active');
			}, 2000);

		})




	}

}

function closeAlerts(){
	$('.alert .close').click(function(){
		$(this).parents('.alert').remove();
	});

}





$(document).ready(function() {
	customProgressSlider();
	closeAlerts();
	tel_mask();
	onlyDigit();


	activeMenuItem();
	activeCatItem();


	customLabelInput();

	setTimeout(function () {
		//fixTopLine();
		//$('input[name=\'telephone\']').mask("+38 (099) 999 99 99");
		customSelectInit();
	}, 600);

	openCloseSearch();

	fixTopLine();
	mainSlideshow();
	productsSlider();
	advantagesPopup();
	sendNewsLetterForm();
	//Mobiles script
	showHideMobileSearch();
	mobileMenuOpenClose();
	mobileMenuSublevels();
	toggleFooterMobile();
	scrollToUp();

	hideShowMoreButton();
	catDescToggle();
	mobileFiltering();


	quickLogin();
	quickRegister();
	openLoginRegister();
	resetPassword();
	goToUserCabinet();

	productPageSlider();
	openSharingBlock();
	addToCartFromProductCard();
	changeQty();

	relatedArticlesSlider();

	sendContactsForm();

	simplecheckoutPageHacks();
	/**********************************/



	// Currency
	$('.form-currency .currency-select').on('click', function(e) {
		e.preventDefault();
		$('.form-currency input[name=\'code\']').val($(this).attr('name'));
		$('.form-currency').submit();
	});

	// Language
	$('.form-language .language-select').on('click', function(e) {
		e.preventDefault();
		$('.form-language input[name=\'code\']').val($(this).attr('name'));
		$('.form-language').submit();
	});


	/* Search */
	$('.search input[name=\'search\']').parents('.search').find('button.search_button').on('click', function() {
		var url = $('base').attr('href') + 'index.php?route=product/search';
		var value = $(this).parents('.search').find('input[name=\'search\']').val();
		if (value) {
			url += '&search=' + encodeURIComponent(value);
		}
		location = url;
	});
	$('.search input[name=\'search\']').on('keydown', function(e) {
		console.log('keydown');
		if (e.keyCode == 13) {
			//$('.search input[name=\'search\']').closest('.search').find('button').trigger('click');
			$(this).parents('.search').find('button').trigger('click');
		}
	});




});


var cart = {
	'add': function(product_id, quantity) {
		$.ajax({
			url: 'index.php?route=checkout/cart/add',
			type: 'post',
			data: 'product_id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
			dataType: 'json',
			beforeSend: function() {
				//$('.cart > button').button('loading');
			},
			complete: function() {
				//$('.cart > button').button('reset');
			},
			success: function(json) {
				$('.alert-dismissible, .text-danger').remove();

				if (json['redirect']) {
					location = json['redirect'];
				}

				if (json['success'])

					if (json['dataLayer'] && typeof dataLayer !== 'undefined') {
						$('body').append(json['dataLayer']);
					}

				if (json['fbq'] && typeof fbq !== 'undefined') {
					$('body').append(json['fbq']);
				}



				setTimeout(function () {

						$("#modal_container_addcart #cart_popup_product_list > ul").load("index.php?route=common/cart/info ul li", function () {

							$('#modal_container_addcart .modal-header .title span').text('(' + json['total'] + ')');

							setTimeout(function () {
								onlyDigit()
							}, 100);
							$('#modal_container_addcart').modal();
						});


						let product_name = $('#product .product__top_block h1.name a').text();
						$('#modal_cart .info').text(product_name);

						$('.cart_button .cart-total' ).html(json['total']);
						$('.cart_button .cart-total').addClass('active');


						$('#modal_cart').addClass('active');

						$('#modal_cart .heading button').click(function(){
							$('#modal_cart').removeClass('active');
						});
						setTimeout(function () {
							$('#modal_cart').removeClass('active');
						}, 4000);


					}, 100);
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},

	'update': function(key, quantity) {
		$.ajax({
			url: 'index.php?route=checkout/cart/editAjax',
			type: 'post',
			//data: 'key=' + key + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
			//data: 'quantity[' + key + ']=' + quantity,
			data: 'quantity[' + key + ']=' + quantity + '&product_id=' + product_id,
			dataType: 'json',
			beforeSend: function() {
				//$('.cart > button').button('loading');
			},
			complete: function() {
				//$('.cart > button').button('reset');
			},
			success: function(json) {

				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {
					$('#modal_container_addcart .modal-header .title span' ).html('('+json['total']+')');
					$('.cart_button .cart-total' ).html(json['total']);
					$('.cart_button .cart-total').addClass('active');

					// Change product subtotal in line
					$('#cart_popup_product_list .qty_total_col .total-'+ key).html(json['changed_product_total']);
					$('#modal_container_addcart .totals_checkout_block .total-total .value').html(json['total_sum']);
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart > ul').load('index.php?route=common/cart/info ul li');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function(key) {
		$.ajax({
			url: 'index.php?route=checkout/cart/removeAjax',
			type: 'post',
			data: 'key=' + key,
			dataType: 'json',
			beforeSend: function() {
				$('.cart > button').button('loading');
			},
			complete: function() {
				$('.cart > button').button('reset');
			},
			success: function(json) {

				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {

					if(json['total'] == 0){
						$('.cart_button .cart-total').removeClass('active');
						$('#modal_container_addcart').modal('hide');
					}

					$('#modal_container_addcart .modal-header .title span' ).html('('+json['total']+')');
					$('.cart_button .cart-total' ).html(json['total']);
					$('#cart_popup_product_list .line-'+ key).remove();

					// Change product subtotal in line
					$('#cart_popup_product_list .qty_total_col .total-'+ key).html(json['changed_product_total']);
					$('#modal_container_addcart .totals_checkout_block .total-total .value').html(json['total_sum']);
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart > ul').load('index.php?route=common/cart/info ul li');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	}
}

var voucher = {
	'add': function() {

	},
	'remove': function(key) {
		$.ajax({
			url: 'index.php?route=checkout/cart/remove',
			type: 'post',
			data: 'key=' + key,
			dataType: 'json',
			beforeSend: function() {
				$('.cart > button').button('loading');
			},
			complete: function() {
				$('.cart > button').button('reset');
			},
			success: function(json) {
				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {
					$('.cart > button').html('<span class="cart-total">' + json['total'] + '</span>');
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart > ul').load('index.php?route=common/cart/info ul li');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	}
}



var wishlist = {
	'add': function(product_id) {
		$.ajax({
			url: 'index.php?route=account/wishlist/add',
			type: 'post',
			data: 'product_id=' + product_id,
			dataType: 'json',
			success: function(json) {

				$('.alert-dismissible').remove();
				if (json['redirect']) {
					location = json['redirect'];
				}

				if (json['success']) {


					var list, index;
					list = document.getElementsByClassName('wishlist-' + product_id);
					for (index = 0; index < list.length; ++index) {
						list[index].setAttribute('disabled', 'disabled');
						list[index].title = json['in_wishlist'];
						var product = list[index];

						$('.modal_wishlist .info').text(json['product_name']);
						$('.wishlist-button .wishlist-total' ).html(json['total']);
						$('.wishlist-button .wishlist-total').addClass('active')
					}

					$('.modal_wishlist').addClass('active');

					setTimeout(function () {
						$('.modal_wishlist').removeClass('active');
					}, 4000);
				}
				//$('html, body').animate({ scrollTop: 0 }, 'slow');
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function() {

	}
}


var compare = {
	'add': function(product_id) {
		$.ajax({
			url: 'index.php?route=product/compare/add',
			type: 'post',
			data: 'product_id=' + product_id,
			dataType: 'json',
			success: function(json) {
				$('.alert-dismissible').remove();

				if (json['success']) {
					//$('#content').parent().before('<div class="alert alert-success alert-dismissible"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>');
					//$('#compare-total').html(json['total']);
					//$('html, body').animate({ scrollTop: 0 }, 'slow');


					var list, index;
					list = document.getElementsByClassName('compare-' + product_id);
					for (index = 0; index < list.length; ++index) {
						list[index].setAttribute('disabled', 'disabled');
						var product = list[index];
						var product_name = $(product).parents('.product').find('.name a').html();


						$('#modal_compare .info').text(product_name);

						$('.compare-total-counter' ).html(json['total']);
						$('.compare-total-counter').addClass('active')
					}

					$('#modal_compare').addClass('active');

					$('#modal_compare .heading button').click(function(){
						$('#modal_compare').removeClass('active');
					});
					setTimeout(function () {
						$('#modal_compare').removeClass('active');
					}, 5000);



				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function() {

	}
}

/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
	e.preventDefault();

	$('#modal-agree').remove();

	var element = this;

	$.ajax({
		url: $(element).attr('href'),
		type: 'get',
		dataType: 'html',
		success: function(data) {
			html  = '<div id="modal-agree" class="modal">';
			html += '  <div class="modal-dialog">';
			html += '    <div class="modal-content">';
			html += '      <div class="modal-header">';
			html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
			html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
			html += '      </div>';
			html += '      <div class="modal-body">' + data + '</div>';
			html += '    </div>';
			html += '  </div>';
			html += '</div>';

			$('body').append(html);

			$('#modal-agree').modal('show');
		}
	});
});

// Autocomplete */
(function($) {
	$.fn.autocomplete = function(option) {
		return this.each(function() {
			this.timer = null;
			this.items = new Array();

			$.extend(this, option);

			$(this).attr('autocomplete', 'off');

			// Focus
			$(this).on('focus', function() {
				this.request();
			});

			// Blur
			$(this).on('blur', function() {
				setTimeout(function(object) {
					object.hide();
				}, 200, this);
			});

			// Keydown
			$(this).on('keydown', function(event) {
				switch(event.keyCode) {
					case 27: // escape
						this.hide();
						break;
					default:
						this.request();
						break;
				}
			});

			// Click
			this.click = function(event) {
				event.preventDefault();

				value = $(event.target).parent().attr('data-value');

				if (value && this.items[value]) {
					this.select(this.items[value]);
				}
			}

			// Show
			this.show = function() {
				var pos = $(this).position();

				$(this).siblings('ul.dropdown-menu').css({
					top: pos.top + $(this).outerHeight(),
					left: pos.left
				});

				$(this).siblings('ul.dropdown-menu').show();
			}

			// Hide
			this.hide = function() {
				$(this).siblings('ul.dropdown-menu').hide();
			}

			// Request
			this.request = function() {
				clearTimeout(this.timer);

				this.timer = setTimeout(function(object) {
					object.source($(object).val(), $.proxy(object.response, object));
				}, 200, this);
			}

			// Response
			this.response = function(json) {
				html = '';

				if (json.length) {
					for (i = 0; i < json.length; i++) {
						this.items[json[i]['value']] = json[i];
					}

					for (i = 0; i < json.length; i++) {
						if (!json[i]['category']) {
							html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
						}
					}

					// Get all the ones with a categories
					var category = new Array();

					for (i = 0; i < json.length; i++) {
						if (json[i]['category']) {
							if (!category[json[i]['category']]) {
								category[json[i]['category']] = new Array();
								category[json[i]['category']]['name'] = json[i]['category'];
								category[json[i]['category']]['item'] = new Array();
							}

							category[json[i]['category']]['item'].push(json[i]);
						}
					}

					for (i in category) {
						html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

						for (j = 0; j < category[i]['item'].length; j++) {
							html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
						}
					}
				}

				if (html) {
					this.show();
				} else {
					this.hide();
				}

				$(this).siblings('ul.dropdown-menu').html(html);
			}

			$(this).after('<ul class="dropdown-menu"></ul>');
			$(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

		});
	}
})(window.jQuery);